import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  LEAVE_ENTITLEMENT_LIST_REQUEST,
  LEAVE_ENTITLEMENT_LIST_SUCCESS,
  LEAVE_ENTITLEMENT_LIST_FAILURE,
  LEAVE_ENTITLEMENT_LIST_RESET,
  LEAVE_ENTITLEMENT_CREATE_REQUEST,
  LEAVE_ENTITLEMENT_CREATE_SUCCESS,
  LEAVE_ENTITLEMENT_CREATE_FAILURE,
  LEAVE_ENTITLEMENT_CREATE_RESET,
  LEAVE_ENTITLEMENT_GET_REQUEST,
  LEAVE_ENTITLEMENT_GET_SUCCESS,
  LEAVE_ENTITLEMENT_GET_FAILURE,
  LEAVE_ENTITLEMENT_GET_RESET,
  LEAVE_ENTITLEMENT_EDIT_REQUEST,
  LEAVE_ENTITLEMENT_EDIT_SUCCESS,
  LEAVE_ENTITLEMENT_EDIT_FAILURE,
  LEAVE_ENTITLEMENT_EDIT_RESET,
  LEAVE_ENTITLEMENT_DELETE_REQUEST,
  LEAVE_ENTITLEMENT_DELETE_SUCCESS,
  LEAVE_ENTITLEMENT_DELETE_FAILURE,
  LEAVE_ENTITLEMENT_DELETE_RESET,
  LEAVE_ENTITLEMENT_EXPORT_REQUEST,
  LEAVE_ENTITLEMENT_EXPORT_SUCCESS,
  LEAVE_ENTITLEMENT_EXPORT_FAILURE,
  LEAVE_ENTITLEMENT_EXPORT_RESET,
} from './../../constants'

export function createLeaveEntitlement(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-entitlements`,
      method: 'POST',
      types: [
        LEAVE_ENTITLEMENT_CREATE_REQUEST,
        LEAVE_ENTITLEMENT_CREATE_SUCCESS,
        LEAVE_ENTITLEMENT_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}
export function getLeaveEntitlement(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-entitlements`,
      method: 'GET',
      types: [
        LEAVE_ENTITLEMENT_LIST_REQUEST,
        LEAVE_ENTITLEMENT_LIST_SUCCESS,
        LEAVE_ENTITLEMENT_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function getLeaveEntitlementByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-entitlements/${id}`,
      method: 'GET',
      types: [
        LEAVE_ENTITLEMENT_GET_REQUEST,
        LEAVE_ENTITLEMENT_GET_SUCCESS,
        LEAVE_ENTITLEMENT_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function editLeaveEntitlement(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-entitlements/${id}`,
      method: 'PUT',
      types: [
        LEAVE_ENTITLEMENT_EDIT_REQUEST,
        LEAVE_ENTITLEMENT_EDIT_SUCCESS,
        LEAVE_ENTITLEMENT_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}
export function deleteLeaveEntitlement(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-entitlements/${id}/delete`,
      method: 'PUT',
      types: [
        LEAVE_ENTITLEMENT_DELETE_REQUEST,
        LEAVE_ENTITLEMENT_DELETE_SUCCESS,
        LEAVE_ENTITLEMENT_DELETE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportLeaveEntitlement(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-entitlements/exports`,
      method: 'GET',
      types: [
        LEAVE_ENTITLEMENT_EXPORT_REQUEST,
        LEAVE_ENTITLEMENT_EXPORT_SUCCESS,
        LEAVE_ENTITLEMENT_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetGetLeaveEntitlement() {
  return {
    type: LEAVE_ENTITLEMENT_LIST_RESET,
  }
}
export function resetGetLeaveEntitlementByID() {
  return {
    type: LEAVE_ENTITLEMENT_GET_RESET,
  }
}
export function resetCreateLeaveEntitlement() {
  return {
    type: LEAVE_ENTITLEMENT_CREATE_RESET,
  }
}
export function resetEditLeaveEntitlement() {
  return {
    type: LEAVE_ENTITLEMENT_EDIT_RESET,
  }
}
export function resetDeleteLeaveEntitlement() {
  return {
    type: LEAVE_ENTITLEMENT_DELETE_RESET,
  }
}
export function resetExportLeaveEntitlement() {
  return {
    type: LEAVE_ENTITLEMENT_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/leave-entitlement/leave-entitlement-action.js